import React, { useEffect, useState, useMemo } from "react";
import moment from "moment";
import {
  ScheduleVisitContain,
  ScheduleTabContain,
} from "../../style/AM/ScheduleVisit";
import { ButtonContain, Card, CardContain } from "../../style/Home";
import Filter from "../../Components/filters";
import Grid from "@mui/material/Grid";
import ExcelIcon from "../../assets/images/icons/excel.png";
import debounce from "lodash/debounce";
import dayjs from "dayjs";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TablePagination,
} from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import {
  CommanTableContain,
  ContainerCustom,
  SmartSearchContain,
} from "../../style/table";
import TextField from "@mui/material/TextField";
import SearchIcon from "@mui/icons-material/Search";
import { RadioGroup, FormControlLabel, Radio } from "@mui/material";
import { Loader } from "../../utils/loader";
import {
  GetMvrVisits,
  handleVisitPlan,
  handleRevisedPlanAPI,
} from "../../services/scheduleVisit";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { isDateInCurrentMonth } from "../../utils/helper";
import { NotAvailable } from "../../utils/constants";
// import { formatDate } from "react-datepicker/dist/date_utils";
import ClipLoader from "react-spinners/ClipLoader";
import { useDispatch, useSelector } from "react-redux";
import { resetFilter } from "../../features/filterSlice";
import { GetRevisitPlanData, UpdateRevisitActionRequest } from "../../services/scheduleVisit";

const RequestRevisit = () => {
  const [loader, setLoader] = useState(false);
  const [revisedVisitPlanData, setRevisedVisitPlanData] = useState([]);
  const dispatch = useDispatch();
  const filtersValue = useSelector((state) => state.filterData);
  const [selectedActionStatus, setSelectedActionStatus] = useState("");
  const [revisedActionReason, setRevisedActionReason] = useState("");
  const [resetTrigger, setResetTrigger] = useState(false);
  const [filterValues, setFilterValues] = useState({});

  const [isDispatched, setIsDispatched] = useState(false);


  const RevisedVisitPlanData = async () => {
      try {
        setLoader(true);
        let payload = filtersValue;
        const res = await GetRevisitPlanData({ payload: payload });
        if (res.success) {
          setRevisedVisitPlanData(res?.data?.revisedVisitPlanData)
        }
      } catch (error) {
        console.log("error: ", error);
        toast.error(error?.response?.data?.error || "network error")
      } finally {
        setLoader(false);
      }
  };

  const handleRevisedVisitActionSubmit = async(evaluatorCode, dealerCode, revisitDate, index) => {
    if(!selectedActionStatus[index] && revisedActionReason[index]){
      toast.warning("select action on revised plan before submitting");
      return;
    }
    try{
      let formattedDate = moment(revisitDate, "DD-MM-YYYY").format("YYYY-MM-DD")
      const payload = {
        evaluatorCode: evaluatorCode,
        dealerCode: dealerCode,
        revisedPlanAction: selectedActionStatus[index],
        revisedPlanActionReason: revisedActionReason[index],
        revisedRequestVisitPlanDate: formattedDate,
      } 
      const response = await UpdateRevisitActionRequest({payload: payload})
      if (response.success){
        toast.success(response.message);
        setRevisedVisitPlanData((prevData) => prevData.filter((_, i) => i !== index));
        setSelectedActionStatus((prevState) => {
          const newState = { ...prevState };
          delete newState[index];
          return newState;
        });
        setRevisedActionReason((prevState) => {
          const newState = { ...prevState };
          delete newState[index];
          return newState;
        });
      }
    }catch(error){
      console.log("Error on updating revised action: ", error)
      toast.error("Network Error")
    }
  }

  useEffect(() => {
    if (isDispatched) {
      RevisedVisitPlanData();
    }
  }, [isDispatched]);

  useEffect(() => {
    dispatch(resetFilter());
    setIsDispatched(true);
  }, [dispatch]);

  const handleFilterChange = (filterKey, value) => {
    setFilterValues((prev) => ({
      ...prev, // Keep previous values
      [filterKey]: value, // Update the specific field
    }));
  };

  const handleSearch = async () => {
    await RevisedVisitPlanData();
  };

  const handleActionStatusChange = (index, value) => {
    setSelectedActionStatus((prevState) => ({
      ...prevState,
      [index]: value,
    }));
  };

  const handleActionReasonChange = (index, value) => {
    setRevisedActionReason((prevState) => ({
      ...prevState,
      [index]: value,
    }));
  };

  const mvrTableCols = [
    "Evaluator Code",
    "Evaluator Name",
    "Dealer Code",
    "Dealership Name",
    "LOI Holder",
    "Request Visit Plan Date",
    "Requested Visit Reason",
    "Requested For Revisit AT",
    "ZM Action",
    "Remarks",
    "Action",
  ];

  const handleReset = () => {
    dispatch(resetFilter());
    setResetTrigger(Date.now());
    setTimeout(() => setResetTrigger(false), 0);
  };

  return (
    <>
      {loader && <Loader fullScreen={true} />}
      <ScheduleVisitContain>
        {/* filter start  */}
        <CardContain>
          <Card mt={1} className="Filter_bg">
            <Grid container spacing={1}>
              <Filter
                onFilterChange={handleFilterChange}
                reset={resetTrigger}
              ></Filter>

              <Grid item xs={12}>
                <ButtonContain>
                  <button onClick={handleSearch} className="SearchButton">
                    Search
                  </button>
                  <button className="ResetButton" onClick={handleReset}>
                    Reset
                  </button>
                  {/* <button className="ExportButton">
                    <img src={ExcelIcon} alt="Excel icon" />
                  </button> */}
                </ButtonContain>
              </Grid>
            </Grid>
          </Card>
        </CardContain>
        {/* filter end */}
        <CardContain>
          <Card mt={2}>


            {/* {selectedTab === "dvr_visit" && (
              <> */}
                {/*  table start */}
                {/* Table */}
                <CommanTableContain>
                  <Table stickyHeader>
                    <TableHead>
                      <TableRow>
                        {mvrTableCols.map((text, index) => (
                          <TableCell key={index} sx={{
                            position: 'sticky',
                            top: 0,
                            left: index === 0 ? 0 : 'initial',
                            backgroundColor: 'white',
                            zIndex: index === 0 ? 10 : 9,
                          }}>{text}</TableCell>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                        {revisedVisitPlanData.map((visitPlanData, index) => (
                          <TableRow key={index}>
                            <TableCell sx={{position: 'sticky',left: 0,zIndex: 8,}}>{visitPlanData.evaluatorCode}</TableCell>
                            <TableCell>{visitPlanData.evaluatorName}</TableCell>
                            <TableCell>{visitPlanData.dealerCode}</TableCell>
                            <TableCell>{visitPlanData.dealerShipName}</TableCell>
                            <TableCell>{visitPlanData.loiHolderName}</TableCell>
                            <TableCell>{visitPlanData.requestVisitPlanDate}</TableCell>
                            <TableCell>{visitPlanData.requestVisitReason}</TableCell>
                            <TableCell>{visitPlanData.requestVisitAt}</TableCell>
                          <TableCell>
                          <select className="table_dropdown"
                            onChange={(e) => handleActionStatusChange(index, e.target.value)}
                            value={selectedActionStatus[index] || ""}
                          >
                              <option value="">Select</option>
                              <option value="approved">Approved</option>
                              <option value="rejected">Rejected</option>
                          </select>
                      </TableCell>
                      <TableCell><textarea className="text_area_min" 
                        placeholder="Action Remarks" 
                        value={revisedActionReason[index] || ""}
                        onChange={(e) => handleActionReasonChange(index, e.target.value)}/>
                      </TableCell>
                      <TableCell><button className="action save" onClick={()=>handleRevisedVisitActionSubmit(visitPlanData?.evaluatorCode, visitPlanData?.dealerCode, visitPlanData?.requestVisitPlanDate, index)}>Submit</button></TableCell>
                        </TableRow>
                        ))}
                    </TableBody>
                  </Table>
                </CommanTableContain>

                {/* table end */}
              {/* </>
            )} */}
          </Card>
        </CardContain>
      </ScheduleVisitContain>
      <ToastContainer />
    </>
  );
};

export default RequestRevisit;
